import {
  Checkbox,
  FieldSet,
  FormHelp,
  Grid,
  Heading,
  Label,
  LabeledControl,
  Legend,
  Paragraph,
} from '@zillow/constellation';
import { Controller } from 'react-hook-form';
import { FIELD_IDS } from '../../../pages/TenantDrivenLeaseRenewal';

export function ShareSomeDetailsAboutYourTenancy() {
  return (
    <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)" gridColumn="1 / -1">
      <Grid gridColumnEnd={{ sm_lte: 'span 12', md: 'span 8', xl: 'span 6' }}>
        <Heading level={3} as="h2" marginBottom="sm" fontFamily="serif">
          Share some details about your tenancy
        </Heading>
        <Paragraph marginBottom="md" color="text.secondary">
          Pick from these suggestions to highlight the ways you’ve been a responsible tenant. We’ll use this to draft a
          message to your landlord.
        </Paragraph>
        <FieldSet
          optional
          legend={<Legend>Tenancy details</Legend>}
          description={<FormHelp>We recommend only choosing two or three</FormHelp>}
        >
          <Controller
            name={FIELD_IDS.PAY_RENT_ON_TIME_CHECKED}
            render={({ field: { value, onChange } }) => (
              <LabeledControl
                label={<Label>You always pay rent on time</Label>}
                control={<Checkbox checked={!!value} onChange={(e) => onChange(e.target.checked)} />}
              />
            )}
          />
          <Controller
            name={FIELD_IDS.TAKES_CARE_OF_PROPERTY_CHECKED}
            render={({ field: { value, onChange } }) => (
              <LabeledControl
                label={<Label>You take good care of the property</Label>}
                control={<Checkbox checked={!!value} onChange={(e) => onChange(e.target.checked)} />}
              />
            )}
          />
          <Controller
            name={FIELD_IDS.RARELY_REQUESTS_REPAIRS_CHECKED}
            render={({ field: { value, onChange } }) => (
              <LabeledControl
                label={<Label>You rarely request repairs unless necessary</Label>}
                control={<Checkbox checked={!!value} onChange={onChange} />}
              />
            )}
          />
          <Controller
            name={FIELD_IDS.NO_NOISE_COMPLAINTS_CHECKED}
            render={({ field: { value, onChange } }) => (
              <LabeledControl
                label={<Label>You have no noise complaints or other issues with neighbors</Label>}
                control={<Checkbox checked={!!value} onChange={onChange} />}
              />
            )}
          />
        </FieldSet>
      </Grid>
    </Grid>
  );
}
